<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-vuetify"
      :title="$t('sections.aboutOurProduct.header')"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
import Translations from '@/services/Translations'

  export default {
    name: 'SectionAboutOurProduct',
    mounted(){
      Translations.selsectedLanguage$.subscribe(() => this.cards = Translations.getMessages().sections.aboutOurProduct.cards);
    },
    data: () => ({
      cards: []
    }),
  }
</script>
